export default {
  lang: { name: 'Français', code: 'fr', flag: '🇫🇷' },
  common: {
    whatsapp: 'WhatsApp',
    email: 'E-mail',
    sendEmail: 'Envoyer un e-mail',
    sendInquiry: 'Envoyer une demande',
    contactSupplier: 'Contacter le fournisseur',
    viewDetails: 'Voir les détails',
    viewAll: 'Voir tout',
    loading: 'Chargement…',
    backHome: 'Retour à l\'accueil',
    negotiable: 'Prix négociable',
    perPiece: '/ pièce',
    moq: 'MOQ : 1 pièce',
    inStock: 'En stock',
    refresh: 'rafraîchir',
    chatNow: 'Discuter maintenant',
    chooseContact: 'Choisissez un contact commercial',
    notFound: 'Aucun résultat'
  },
  nav: {
    home: 'Accueil',
    products: 'Produits',
    examples: 'Projets',
    about: 'À propos',
    contact: 'Contact'
  },
  header: {
    callUs: 'Appelez-nous',
    quickNav: 'Navigation rapide',
    tapExpand: 'Touchez pour ouvrir',
    tapClose: 'Touchez pour fermer',
    language: 'Langue'
  },
  hero: {
    tag: 'Fabricant d\'éclairage scénique · Depuis 2010',
    title: 'Illuminez chaque scène<br>avec un éclairage professionnel',
    sub: 'Solutions d\'éclairage scénique de haute qualité — moving head, par, strobe et LED. Exporté dans plus de 50 pays.',
    browseProducts: 'Voir les produits',
    chatWa: 'Discuter sur WhatsApp'
  },
  quicknav: {
    title: 'Navigation rapide',
    products: 'Produits',
    productsDesc: 'Parcourir tous les éclairages',
    examples: 'Projets',
    examplesDesc: 'Réalisations concrètes',
    about: 'À propos',
    aboutDesc: 'Usine et entreprise',
    contact: 'Ventes',
    contactDesc: 'WhatsApp pour devis rapide'
  },
  featured: {
    eyebrow: 'MEILLEURES VENTES',
    title: 'Produits en vedette',
    desc: 'Nos éclairages scéniques les plus populaires — la confiance de clients dans plus de 50 pays.',
    viewAll: 'Voir tous les produits',
    badge: 'Top',
    empty: 'Aucun produit en vedette pour le moment.'
  },
  sections: {
    whyEyebrow: 'POURQUOI NOUS CHOISIR',
    whyTitle: 'Nos avantages',
    whyDesc: 'Forts d\'une expérience étendue, nous excellons en innovation et en production à grande échelle, offrant des solutions d\'éclairage scénique de haute qualité conformes aux normes mondiales.',
    svcEyebrow: 'CE QUE NOUS OFFRONS',
    svcTitle: 'Nos services',
    svcDesc: 'Une gamme complète de solutions d\'éclairage scénique — des produits personnalisés à l\'expédition mondiale et au support technique à distance.',
    contactEyebrow: 'CONTACTEZ-NOUS',
    contactTitle: 'Envoyez une demande',
    contactDesc: 'Préférez-vous l\'e-mail ? Laissez vos coordonnées et nous vous répondrons sous 24 heures.'
  },
  cta: {
    title: 'Besoin d\'un devis en quelques minutes ?',
    desc: 'Écrivez-nous sur WhatsApp — notre équipe commerciale répond généralement en 10 minutes pendant les heures ouvrables.',
    emailUs: 'E-mail'
  },
  product: {
    heroTitle: 'Produits',
    heroDesc: 'Éclairage scénique de haute qualité, contrôle flexible, stabilité exceptionnelle et sécurité fiable — conçu pour sublimer chaque représentation et événement.',
    searchPlaceholder: 'Rechercher des produits par mot-clé...',
    search: 'Rechercher',
    sortBy: 'Trier par',
    sortDefault: 'Par défaut',
    sortNewest: 'Plus récents',
    sortAsc: 'Prix : croissant',
    sortDesc: 'Prix : décroissant',
    categories: 'Catégories',
    results: 'produits',
    in: 'dans',
    filterToggle: 'Catégories',
    allTypes: 'Tous',
    noImg: 'Pas d\'img'
  },
  productDetails: {
    loadingProduct: 'Chargement du produit…',
    notFound: 'Produit introuvable.',
    backToProducts: '← Retour aux produits',
    keyAttributes: 'Attributs clés',
    moreSpecs: 'plus de spécifications',
    blockDescription: 'Description du produit',
    noDescription: 'Aucune description.',
    blockSpecs: 'Spécifications',
    noSpecs: 'Aucune spécification.',
    blockFaq: 'Questions fréquentes',
    inquiryTitle: 'Envoyez une demande',
    inquiryDesc: 'Dites-nous ce dont vous avez besoin — nous répondons généralement sous 24 heures.',
    priceMeta: 'MOQ : 1 pièce · Remises en volume disponibles'
  },
  example: {
    heroTitle: 'Projets',
    heroDesc: 'Installations réelles et productions scéniques propulsées par nos solutions d\'éclairage dans le monde entier.',
    ctaWa: 'Obtenir une installation similaire',
    empty: 'Aucun projet dans cette catégorie pour le moment.'
  },
  about: {
    heroTitle: 'À propos',
    heroSub: 'Guangzhou Huayang Stage Lighting — fabricant dédié d\'éclairage scénique professionnel depuis 2010.',
    companyEyebrow: 'NOTRE ENTREPRISE',
    purposeEyebrow: 'NOTRE OBJECTIF',
    purposeTitle: 'Illuminer les scènes, briller vers l\'avenir',
    teamEyebrow: 'CONTACTEZ NOTRE ÉQUIPE',
    teamTitle: 'Service client',
    teamDesc: 'Contactez directement nos spécialistes commercial — WhatsApp est le moyen le plus rapide d\'obtenir un devis.',
    notSure: 'Vous ne savez pas qui contacter ?',
    routeMsg: 'Écrivez à notre ligne principale et nous vous orienterons vers la bonne personne.',
    leaveEyebrow: 'OU LAISSEZ-NOUS UN MESSAGE',
    leaveTitle: 'Laissez vos coordonnées',
    leaveDesc: 'L\'e-mail est aussi bienvenu — nous répondons sous 24 heures.',
    statYears: 'Ans',
    statCountries: 'Pays',
    statUnits: 'Unités/An',
    statFactory: 'm² Usine',
    whyList1: 'Prix direct usine',
    whyList2: 'Expédition mondiale',
    whyList3: 'Qualité garantie'
  },
  footer: {
    productCenter: 'Centre de produits',
    viewAllProducts: 'Voir tous les produits',
    aboutTitle: 'À propos',
    aboutText: 'Guangzhou Huayang Stage Lighting, fondée en 2010, est spécialisée dans les équipements d\'éclairage scénique tels que les moving heads et les LED. Exportant vers plus de 50 pays, nous sommes reconnus pour nos produits de haute qualité et notre excellent service client.',
    contact: 'Contact',
    chatWa: 'Discuter sur WhatsApp',
    rights: 'Tous droits réservés.',
    waLabel: 'réponse rapide',
    workingHours: 'Heures d\'ouverture'
  },
  leaveMessage: {
    fastest: 'Réponse la plus rapide',
    title: 'Écrivez-nous sur WhatsApp',
    replyMin: 'Notre équipe commerciale répond généralement en <b>10 minutes</b> pendant les heures ouvrables ({hours}).',
    orEmail: 'ou envoyez un e-mail',
    formTitle: 'Envoyez-nous un e-mail',
    formSub: 'Remplissez le formulaire — nous répondons sous 24 heures.',
    fullName: 'Nom complet *',
    fullNamePh: 'Votre nom',
    phone: 'Téléphone *',
    phonePh: 'Inclure l\'indicatif pays',
    emailLbl: 'E-mail *',
    emailPh: 'you@example.com',
    message: 'Message *',
    messagePh: 'Dites-nous quels produits vous intéressent, quantités, destination, etc.',
    codePh: 'Entrez le code',
    privacy: 'Vos informations restent confidentielles et servent uniquement à répondre à votre demande.',
    errCode: 'Veuillez entrer le code de vérification.',
    errForm: 'Veuillez fournir des informations complètes et valides.',
    okSent: 'Votre message a été envoyé avec succès !',
    errCodeInvalid: 'Code de vérification invalide, veuillez réessayer.',
    errFail: 'Échec de l\'envoi. Veuillez réessayer plus tard.'
  },
  trust: {
    assurance: 'Garantie commerciale',
    assuranceDesc: 'Protection de commande intégrée',
    shipping: 'Expédition mondiale',
    shippingDesc: 'Mer / Air / Express',
    quality: 'Qualité vérifiée',
    qualityDesc: 'Direct usine'
  },
  stats: {
    years: '14+',
    yearsLbl: 'Ans',
    countries: '50+',
    countriesLbl: 'Pays',
    units: '100k+',
    unitsLbl: 'Unités/An',
    factory: '7200',
    factoryLbl: 'm² Usine'
  }
};
